module.exports = __webpack_public_path__ + "static/media/promo-management-1.f07de678.png";